export default __webpack_public_path__ + "static/media/checkmark-icon.4b0741be.svg";